import { render } from "./OffersList.vue?vue&type=template&id=0408ea07"
import script from "./OffersList.vue?vue&type=script&lang=js"
export * from "./OffersList.vue?vue&type=script&lang=js"

import "./OffersList.vue?vue&type=style&index=0&id=0408ea07&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__